<div class="feedback-dialog">
  <!-- Main Content -->
  <div class="display-flex padding-dialog dialog-header">
    <div class="float-left">
      <div class="dialog-header-title">
        <img
          [class]="isLikeDialog ? 'icon-positive' : 'icon-negative'"
          [src]="isLikeDialog ? '../../../assets/icons/icon-positive-feedback.png' : '../../../assets/icons/icon-negative-feedback.png'"
          alt=""
          height="22px"
        />
        <h1>{{ isLikeDialog ? 'Positive Feedback' : 'Negative Feedback' }}</h1>
      </div>
    </div>
    <div class="float-right">
      <span class="close-dialog" (click)="onCancel()">
        <img src="../../../assets/icons/icon-close.png" alt="Close" width="16" />
      </span>
    </div>
  </div>

  <div class="padding-dialog">
    <p class="smalltext">Your feedback is essential for improving product experience.</p>
    <h2>{{ isLikeDialog ? 'How would you rate this response?' : 'What went wrong?' }}</h2>

    <mat-dialog-content class="bottom-div">
      <!-- Radio Options -->
      <div class="block">
        <mat-radio-group [(ngModel)]="selectedOption" (ngModelChange)="onOptionChange()">
          @for (option of radioOptions; track option.feedback_metadata_id) {
            <mat-radio-button [value]="option.feedback_metadata_id">
              <span class="rad-span">
                <span class="icon-option">
                  <img [src]="'../../../assets/icons/' + option.feedback_value.split(' ').join('-') + '.png'" alt="" height="16px" />
                </span>
                <span class="txt-option">{{ option.feedback_value }}</span>
              </span>
            </mat-radio-button>
          }
        </mat-radio-group>
        <div *ngIf="showError" class="required">
          Please select any one option.
        </div>
      </div>

      <!-- Comments -->
      <div class="block">
        <label class="txt-label">Comments <span class="required">*</span></label>
        <mat-form-field class="entercomments textarea-field" appearance="fill">
          <textarea
            placeholder="Please add your comments..."
            matInput
            [(ngModel)]="comment"
            id="Textarea"
            (ngModelChange)="onCommentChange($event)"
          ></textarea>
        </mat-form-field>
        <div *ngIf="commentError" class="required">
          Please provide comments for disliking.
        </div>
      </div>
    </mat-dialog-content>

    <div *ngIf="isSubmitting" class="wait-msg">Please wait, Submitting your feedback...</div>
  </div>

  <!-- Actions -->
  <mat-dialog-actions>
    <app-button [button]="cancelButton" (clicked)="onCancel()"></app-button>
    <app-button [button]="submitButton" (clicked)="onSubmit()" [disabled]="isSubmitting"></app-button>
  </mat-dialog-actions>
</div>
